/* import __COLOCATED_TEMPLATE__ from './duration.hbs'; */
import Component from '@ember/component';

// eslint-disable-next-line ember/no-classic-classes
export default Component.extend({
  tagName: 'span',
  classNames: ['video-player__overlay__duration'],
  attributeBindings: ['data-test-video-player-overlay-duration'],
  'data-test-video-player-overlay-duration': true
});